// extracted by mini-css-extract-plugin
export default {"checkout-summary":"SummaryStudents--checkout-summary--UZNQl","checkoutSummary":"SummaryStudents--checkout-summary--UZNQl"};